<template>
    <div v-loading="dataLoading">
        <table v-if="data && data.id" class="info-table" width="100%">
            <tr>
                <th>认证性质</th>
                <td>{{data.claimType == 1 ? '个人' : '企业'}}</td>
            </tr>
            <template v-if="data.claimType == 1">
                <tr>
                    <th>认证人姓名</th>
                    <td>{{data.name}}</td>
                </tr>
                <tr>
                    <th>认证人证件类型</th>
                    <td>{{data.documentType}}</td>
                </tr>
                <tr>
                    <th>认证人证件号码</th>
                    <td>{{data.documentNumber}}</td>
                </tr>
                <tr>
                    <th>认证人证件</th>
                    <td>
						<template v-if="data.documentPhoto">
							<template v-for="(item,index) in data.documentPhoto">
								<el-image :src="item" :key="index" fit="cover" :preview-src-list="data.documentPhoto"></el-image>
							</template>
						</template>
                    </td>
                </tr>
            </template>
            <template v-if="data.claimType == 2">
                <tr>
                    <th>企业名称</th>
                    <td>{{data.companyName}}</td>
                </tr>
                <tr>
                    <th>营业执照编号</th>
                    <td>{{data.licenseId}}</td>
                </tr>
                <tr>
                    <th>营业执照</th>
                    <td>
						<template v-if="data.licensePic">
							<template v-for="(item,index) in data.licensePic">
								<el-image :src="item" :key="index" fit="cover" :preview-src-list="data.licensePic"></el-image>
							</template>
						</template>
                    </td>
                </tr>
                <tr>
                    <th>法人代表姓名</th>
                    <td>{{data.corporationName}}</td>
                </tr>
                <tr>
                    <th>法人代表身份证号码</th>
                    <td>{{data.corporationId}}</td>
                </tr>
                <tr>
                    <th>法人代表身份证</th>
                    <td>
						<template v-if="data.corporationIdPic">
							<template v-for="(item,index) in data.corporationIdPic">
								<el-image :src="item" :key="index" fit="cover" :preview-src-list="data.corporationIdPic"></el-image>
							</template>
						</template>
                    </td>
                </tr>
				<tr>
				    <th>企业类型</th>
				    <td>{{data.businessType == 0 ? '有限责任公司（自然人投资或控股）' : '股份有限公司'}}</td>
				</tr>
				<tr>
				    <th>注册地址</th>
				    <td>{{data.registeredAddress}}</td>
				</tr>
				<tr>
				    <th>注册资本</th>
				    <td>{{data.registeredCapitalStr}}万元</td>
				</tr>
				
            </template>
            <tr>
                <th>额外补充信息</th>
                <td>
                    <template v-if="data.otherPic">
                        <template v-for="(item,index) in data.otherPic">
                            <el-image :src="item" :key="index" fit="cover" :preview-src-list="data.otherPic"></el-image>
                        </template>
                    </template>
                </td>
            </tr>
        </table>
        <div v-if="data && !data.id" class="color-danger">还没有认证信息</div>
    </div>
</template>

<script>
export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        userType:{
            type:[Number,String],
            default:''
        },
        userName:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            dataLoading:false,
            data:null,
            action:{
                2:{ // 艺人
                    userClaimInfo:'/performer/userClaimInfo',
                },
                3:{ // 场地
                    userClaimInfo:'/site/userClaimInfo',
                },
                5:{ // 厂牌
                    userClaimInfo:'/brand/userClaimInfo',
                }
            },
        };
    },
    computed:{
        documentType(){
            return new Map([
                [1,'身份证'],
                [2,'港澳居民来往内地通行证'],
                [3,'台湾居民来往大陆通行证'],
                [4,'护照'],
                [5,'外国人永久居留身份证'],
                [6,'港澳台居民居住证']
            ])
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        //获取认证信息
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.action[this.userType].userClaimInfo,
                method: "POST",
                data: {id: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
                        this.data = result;
                        this.$emit('update:userName',result.idNameVO.name);

                        this.data.documentPhoto = this.data.documentPhoto && this.data.documentPhoto != 'null' ? this.data.documentPhoto.split(',') : [];
                        this.data.otherPic = this.data.otherPic && this.data.otherPic != 'null' ? this.data.otherPic.split(',') : [];
                        this.data.licensePic = this.data.licensePic && this.data.licensePic != 'null' ? this.data.licensePic.split(',') : [];
						this.data.corporationIdPic = this.data.corporationIdPic && this.data.corporationIdPic != 'null' ? this.data.corporationIdPic.split(',') : [];

                    } else {
                        return this.$message.error(msg || "获取认证信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取认证信息失败");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>


<style lang="scss" scoped>
.info-table{
    th{
        width: 140px;
    }
    td{
        .el-image{
            width: 200px;
            height: 120px;
            margin: 5px;
        }
    }
}
</style>